import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ec08aab2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ec08aab2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec08aab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec08aab2')) {
      api.createRecord('ec08aab2', component.options)
    } else {
      api.reload('ec08aab2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ec08aab2&scoped=true", function () {
      api.rerender('ec08aab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/sort/jingdongCate/index.vue"
export default component.exports